import { render, staticRenderFns } from "./gradeAddOrEdit.vue?vue&type=template&id=246d62b3&scoped=true"
import script from "./gradeAddOrEdit.vue?vue&type=script&lang=js"
export * from "./gradeAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./gradeAddOrEdit.vue?vue&type=style&index=0&id=246d62b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246d62b3",
  null
  
)

export default component.exports